<ng-template #footerLink let-link>
  <a
    [href]="link.href"
    [attr.target]="link.newTab ? '_blank' : null"
    [attr.rel]="link.newTab ? 'noopener noreferrer' : null"
    >{{ link.label }}
    @if (link.newTab) {
      <span class="visually-hidden"> (avautuu uuteen välilehteen)</span>
    }
  </a>
</ng-template>

<footer class="site-footer">
  <div class="site-footer__container">
    <div class="site-footer__company">
      <a class="site-footer__logo-link" [href]="homeUrl">
        <img
          class="site-footer__logo"
          ngSrc="/images/rati-logo.png"
          width="371"
          height="35"
          alt="Rakennustieto"
        />
      </a>
      <address class="site-footer__address">
        Malminkatu 16 A, 00100 Helsinki<br />
        Puh. 045 4900 747 |
        <a class="site-footer__strong-link" href="mailto:asiakaspalvelu@rakennustieto.fi"
          >asiakaspalvelu&#64;rakennustieto.fi</a
        ><br />
        Y-tunnus 0113188-9
      </address>
      <ul class="site-footer__legal" role="list">
        @for (link of legalLinks; track link.href) {
          <li>
            <ng-container *ngTemplateOutlet="footerLink; context: { $implicit: link }" />
          </li>
        }
      </ul>
    </div>

    <nav class="site-footer__column" aria-labelledby="site-footer-quick-links">
      <h2 id="site-footer-quick-links" class="site-footer__heading">Pikalinkit</h2>
      <ul role="list">
        @for (link of quickLinks; track link.href) {
          <li>
            <ng-container *ngTemplateOutlet="footerLink; context: { $implicit: link }" />
          </li>
        }
      </ul>
    </nav>

    <nav class="site-footer__column" aria-labelledby="site-footer-contact">
      <h2 id="site-footer-contact" class="site-footer__heading">Ota yhteyttä</h2>
      <ul role="list">
        @for (link of contactLinks; track link.href) {
          <li>
            <ng-container *ngTemplateOutlet="footerLink; context: { $implicit: link }" />
          </li>
        }
      </ul>
    </nav>
  </div>
</footer>
